module.exports = __webpack_public_path__ + "static/media/ab1.6fa683c7.png";